import { Typography, Divider } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import type { FC } from 'react';
import { useEffectOnce } from '../../../../../../../hooks/use-effect-once';
import type {
  NetSuiteConfigurationControl,
  NetSuiteConfigurationFormValues,
} from '../NetSuiteConfigurationFormSchema';
import { useFetchNetSuiteSettings } from '../hooks/useFetchNetSuiteSettings';
import { AccountConfigurationSection } from './sections/AccountConfigurationSection';
import { ProductsConfigurationSection } from './sections/ProductsConfigurationSection';
import { InvoicesConfigurationSection } from './sections/InvoicesConfigurationSection';
import { CreditMemosConfigurationSection } from './sections/CreditMemosConfigurationSection/CreditMemosConfigurationSection';
import { CustomersConfigurationSection } from './sections/CustomersConfigurationSection';
import { TaxConfigurationSection } from './sections/TaxConfigurationSection';
import { PaymentsConfigurationSection } from './sections/PaymentsConfigurationSection';

type NetSuiteConfigurationFormProps = {
  control: NetSuiteConfigurationControl;
};

const FormContainer = ({ children }: { children: React.ReactNode }) => (
  <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '24px' }}>{children}</div>
);

const ConfigurationsContainer = ({ children }: { children: React.ReactNode }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>{children}</div>
);

export const NetSuiteConfigurationForm: FC<NetSuiteConfigurationFormProps> = ({ control }) => {
  const { configuration } = useFetchNetSuiteSettings();
  const { reset } = useFormContext<NetSuiteConfigurationFormValues>();

  useEffectOnce(() => {
    reset(configuration);
  });

  return (
    <FormContainer>
      <Typography variant="h5">Configurations</Typography>
      <ConfigurationsContainer>
        <AccountConfigurationSection control={control} defaultValues={configuration} />
        <Divider />
        <ProductsConfigurationSection control={control} defaultValues={configuration} />
        <Divider />
        <CustomersConfigurationSection control={control} defaultValues={configuration} />
        <Divider />
        <InvoicesConfigurationSection control={control} defaultValues={configuration} />
        <Divider />
        <TaxConfigurationSection control={control} defaultValues={configuration} />
        <Divider />
        <CreditMemosConfigurationSection control={control} defaultValues={configuration} />
        <Divider />
        <PaymentsConfigurationSection control={control} defaultValues={configuration} />
      </ConfigurationsContainer>
    </FormContainer>
  );
};
